import { useEffect } from 'react';
import { useRouter } from 'next/router';

// Wrapper
import LayoutLogged from '@/components/layouts/LayoutLogged';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

// Utils
import useTranslation from 'next-translate/useTranslation';

// Lib
import { albumsTabs } from '@/lib/albums/tabs';
import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';

// Components
import Icon from '@/components/base/Icon';
import Button from '@/components/base/Button';
import AlbumFunnelModal from '@/components/pages/albums/AlbumFunnelModal';
import TabsLink from '@/components/composite/TabsLink';

const AlbumsHeader = () => {
    const { t } = useTranslation();
    const { isOpen: isOpenAlbumFunnel, toggle: toggleAlbumFunnel } = useToggle();

    const router = useRouter();
    const queryAction = router.query[CAMPAIGNS_QUERY_ACTION_PARAM.NAME];
    const { deleteQuery } = useRouterQuery();

    useEffect(() => {
        if (queryAction === CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN) {
            toggleAlbumFunnel();
            const newUrl = deleteQuery(CAMPAIGNS_QUERY_ACTION_PARAM.NAME);
            router.replace(newUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryAction]);

    return (
        <LayoutLogged.Header className="flex flex-wrap items-center justify-between gap-4">
            <TabsLink tabsList={albumsTabs} />
            <div className="w-full md:w-52">
                <Button
                    className="create-new-add w-full space-x-2 md:w-52"
                    onClick={toggleAlbumFunnel}>
                    <Icon icon="plus" />
                    <span>{t('content:create_album')}</span>
                </Button>
            </div>
            <AlbumFunnelModal isOpen={isOpenAlbumFunnel} toggle={toggleAlbumFunnel} />
        </LayoutLogged.Header>
    );
};

export default AlbumsHeader;
